import Action from '../Action';
import { useState, useEffect, useMemo } from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';

const ModalCreateRol = ({
    getRoles, userId, userData, dataRoles, user, languaje, mode, devices,
    server, setRegisterIsValid, dataMantto, setData, loading, setLoading,
    setError, setEditActive, editActive, closCreateCisModal,
    dataPermisos, showInfo, setInfoPermission, RolData, addPermiso,
    rolSelected, setPermisos, getPermisos, setDataPermisos, permisos, setUserData
}) => {
    const [loadingM, setLoadingM] = useState(false);
    const [IpValid, setIpValid] = useState(true);
    const [matchPassword, setMatchPassword] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [host, sethost] = useState([]);

    const [ManttoData, setManttoData] = useState({
        name: (editActive) ? dataMantto.name : "",
        description: (editActive) ? "" : "",
        permissions: (editActive) ? dataMantto.permissions : "1",
        authorizable_group_ids: (editActive) ? dataMantto.authorizable_group_ids : ""
    });
    const [authGroups, setAuthGroups] = useState([]);
    const [hostName, setHostName] = useState("");
    const [hostLocation, setHostLocation] = useState("");
    const [hostActivate, setHostActivate] = useState(0);
    const dataSubgrups = useFetch('cassia/cis_v2/groups/authorizations/subgroups', '', '', 'GET', server);
    const rolesInfo = useFetch('cassia/users/roles/details/' + rolSelected + '', '', '', 'GET', server);

    const [groupsID, setGroupsID] = useState([]);

    useEffect(() => {
        if (editActive && rolesInfo.data.length !== 0) {
            setGroupsID(rolesInfo.data.data.authorizable_group_ids);
            setAuthGroups(rolesInfo.data.data.authorizable_group_ids);
        }
    }, [rolesInfo.data]);

    const [msgError, setMsgError] = useState("");
    const [expandedModule, setExpandedModule] = useState(null);
    const [expandedSubModule, setExpandedSubModule] = useState(null);
    const [moduleSelected, setModuleSelected] = useState({ id: 0, name: '' });
    const [subModuleSelected, setSubModuleSelected] = useState({ id: 0, name: '' });
    const [subModules, setSubModules] = useState([]);
    const [caracters, setCaracters] = useState([]);

    // ─── NUEVO: buscador (no rompe lógica) ──────────────────────────────────
    const [searchTerm, setSearchTerm] = useState('');

    const modules = dataPermisos.data.data.filter(element => element.Nivel === 1);

    // Filtrado por buscador: busca en módulos Y submódulos
    const filteredModules = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (term === '') return modules;

        return modules.filter((mod) => {
            const moduleName = (lang[languaje] && lang[languaje][mod.module_name])
                ? lang[languaje][mod.module_name]
                : mod.module_name;
            const moduleMatches = moduleName.toLowerCase().includes(term);
            if (moduleMatches) return true;

            // También buscar dentro de submódulos del módulo
            const subs = dataPermisos.data.data.filter(el => el.Nivel === 2 && el.name === mod.module_name);
            const someSubMatches = subs.some(sub => {
                const subName = (lang[languaje] && lang[languaje][sub.module_name])
                    ? lang[languaje][sub.module_name]
                    : sub.module_name;
                return subName.toLowerCase().includes(term);
            });
            return someSubMatches;
        });
    }, [modules, searchTerm, dataPermisos.data.data, languaje]);

    // Determina si un submódulo coincide con la búsqueda (para auto-expandir si hace match)
    const submoduleMatchesSearch = (sub) => {
        const term = searchTerm.trim().toLowerCase();
        if (term === '') return false;
        const subName = (lang[languaje] && lang[languaje][sub.module_name])
            ? lang[languaje][sub.module_name]
            : sub.module_name;
        return subName.toLowerCase().includes(term);
    };

    const selectModulo = (e) => {
        setModuleSelected({ id: e.permission_id, name: e.module_name });
        setSubModules(dataPermisos.data.data.filter(element => element.Nivel === 2 && element.name == e.module_name));
        setCaracters([]);
    };

    const selectSubModulo = (e) => {
        setSubModuleSelected({ id: e.permission_id, name: e.module_name });
        if (e.permission_id === 90) {
            setCaracters(dataSubgrups.data.data);
        } else {
            setCaracters(dataPermisos.data.data.filter(element => element.Nivel === 3 && element.name === moduleSelected.name && element.description === e.module_name));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setManttoData((prevState) => ({ ...prevState, [name]: value }));

        if (permisos.length !== 0 && ManttoData.name !== "") {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const [correoIsValid, setCorreoIsValid] = useState(true);
    const [nombreIsValid, setNombreIsValid] = useState(true);

    useEffect(() => {
        if (permisos.length !== 0 && ManttoData.name !== "") {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
        setManttoData((prevState) => ({ ...prevState, ['permissions']: permisos.join(',') }));
    }, [permisos]);

    const Guardar = () => {
        let method = 'POST';
        let url_add = '';
        if (editActive) {
            method = 'PUT';
            url_add = rolSelected;
        }

        setDataPermisos({ data: dataPermisos.data, loading: true, error: '' });
        setLoading(true);

        const fetchDataPost = async () => {
            try {
                const response = await fetch(server.url + '/api/v1/cassia/users/roles/' + url_add, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                    body: JSON.stringify(ManttoData),
                });

                if (response.ok) {
                    const data1 = await response.json();
                    setLoading(false);
                    setUserData({ name: "", description: "", permissions: "" });
                    setPermisos([]);
                    getPermisos();
                    getRoles();
                    setEditActive(false);
                    setDataPermisos({ data: dataPermisos.data, loading: false, error: '' });
                    closCreateCisModal();
                } else {
                    throw new Error('Error en la solicitud');
                }
            } catch (error) {
                setUserData({ name: "", description: "", permissions: "" });
                setPermisos([]);
                setDataPermisos({ data: dataPermisos.data, loading: false, error: '' });
                setLoading(false);
                console.error(error);
            }
        };

        fetchDataPost();
    };

    const handleSelectAll = (e) => {
        e.stopPropagation();
        if (permisos.length > 0 || authGroups.length > 0) {
            setPermisos([]);
            setAuthGroups([]);
            setManttoData(prev => ({ ...prev, authorizable_group_ids: '' }));
        } else {
            const allPermisoIds = dataPermisos.data.data.map(p => p.permission_id);
            const allGroupIds = dataSubgrups.data?.data ? dataSubgrups.data.data.map(g => g.id) : [];
            setPermisos(allPermisoIds);
            setAuthGroups(allGroupIds);
            setManttoData(prev => ({ ...prev, authorizable_group_ids: allGroupIds.join(', ') }));
        }
    };

    const addGroups = (e) => {
        if (authGroups.includes(e)) {
            const resultado = authGroups.filter((permiso) => permiso !== e);
            setAuthGroups(resultado);
            setManttoData((prevState) => ({ ...prevState, ['authorizable_group_ids']: resultado.join(', ') }));
        } else {
            const nuevoArreglo = [...authGroups, e];
            setManttoData((prevState) => ({ ...prevState, ['authorizable_group_ids']: nuevoArreglo.join(', ') }));
            setAuthGroups(nuevoArreglo);
        }
    };

    const { name, mail, roles } = ManttoData;

    // ═══════════════════════════════════════════════════════════════════════
    // PALETA CLEAN BLUE
    // ═══════════════════════════════════════════════════════════════════════
    const C = {
        bl: '#1a56db',
        blDark: '#0f2d5e',
        bl5: '#e8f0fe',
        txt: '#0f172a',
        txt2: '#334155',
        txt3: '#64748b',
        txt4: '#94a3b8',
        b1: '#e2e8f0',
        b2: '#cbd5e1',
        bg: '#f8fafc',
        bg2: '#f1f5f9',
        wh: '#ffffff',
        gr: '#057a55',
        grSoft: '#e8f5ee',
        red: '#e02424',
        redSoft: '#fef2f2',
    };

    // Totales globales
    const totalPermisos = dataPermisos.data.data?.length || 0;
    const totalGroups = dataSubgrups.data?.data?.length || 0;
    const totalSelected = permisos.length + authGroups.length;
    const totalAvailable = totalPermisos + totalGroups;
    const allChecked = totalSelected > 0 && permisos.length >= totalPermisos;

    return (
        <div className="modal-GS-content">
            <div
                className='card-modal-gs modal-verificate'
                style={{
                    background: C.wh,
                    borderRadius: 12,
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(15,45,94,0.25)',
                    border: `1px solid ${C.b1}`,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '90%',
                    maxWidth: 920,
                    maxHeight: '92vh',
                }}
            >
                {/* ═══════════════════════════════════════════════════════════════
            HEADER AZUL MARINO
            ═══════════════════════════════════════════════════════════════ */}
                <div
                    style={{
                        background: C.blDark,
                        padding: '16px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 14,
                        flexShrink: 0,
                    }}
                >
                    <div
                        style={{
                            width: 40, height: 40, borderRadius: 8,
                            background: 'rgba(255,255,255,0.1)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 7h-9" />
                            <path d="M14 17H5" />
                            <circle cx="17" cy="17" r="3" />
                            <circle cx="7" cy="7" r="3" />
                        </svg>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ color: C.wh, fontSize: 16, fontWeight: 600, lineHeight: 1.2 }}>
                            {(editActive ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear']))} ROL
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                            {capitalizeFirstLetter(lang[languaje]['definirRolPermisos'] || 'Define el nombre del rol y asigna permisos')}
                        </div>
                    </div>

                    <button
                        onClick={closCreateCisModal}
                        style={{
                            width: 36, height: 36, borderRadius: 8,
                            background: 'rgba(255,255,255,0.1)',
                            border: 'none', color: C.wh, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0,
                        }}
                        title={capitalizeFirstLetter(lang[languaje]['cerrar'] || 'Cerrar')}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                {/* ═══════════════════════════════════════════════════════════════
            CAMPO NOMBRE DEL ROL + CONTEO
            ═══════════════════════════════════════════════════════════════ */}
                <div
                    style={{
                        background: C.bg,
                        padding: '14px 20px',
                        borderBottom: `1px solid ${C.b1}`,
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        gap: 16,
                        alignItems: 'end',
                        flexShrink: 0,
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
                        <label style={{ fontSize: 11, fontWeight: 600, color: C.txt3, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                            {capitalizeFirstLetter(lang[languaje]['nombreRol'] || 'Nombre del rol')}
                        </label>
                        <input
                            required
                            name="name"
                            type="text"
                            value={name}
                            onChange={handleChange}
                            placeholder={capitalizeFirstLetter(lang[languaje]['nombreRol'] || 'Nombre del rol')}
                            style={{
                                height: 36, padding: '0 12px',
                                border: `1px solid ${C.b1}`, borderRadius: 8,
                                background: C.wh, fontSize: 13, color: C.txt,
                                outline: 'none', width: '100%', boxSizing: 'border-box',
                            }}
                            onFocus={(e) => { e.target.style.borderColor = C.bl; e.target.style.boxShadow = `0 0 0 3px ${C.bl5}`; }}
                            onBlur={(e) => { e.target.style.borderColor = C.b1; e.target.style.boxShadow = 'none'; }}
                        />
                    </div>

                    <div
                        style={{
                            display: 'flex', alignItems: 'center', gap: 8,
                            background: totalSelected > 0 ? C.bl5 : C.bg2,
                            color: totalSelected > 0 ? C.bl : C.txt3,
                            padding: '8px 14px', borderRadius: 999,
                            fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
                            height: 36, boxSizing: 'border-box',
                        }}
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        {totalSelected} / {totalAvailable} {capitalizeFirstLetter(lang[languaje]['permisos'] || 'permisos')}
                    </div>
                </div>

                {/* ═══════════════════════════════════════════════════════════════
            TOOLBAR — Título + Buscador + Seleccionar todos
            ═══════════════════════════════════════════════════════════════ */}
                <div
                    style={{
                        padding: '14px 20px',
                        borderBottom: `1px solid ${C.b1}`,
                        background: C.wh,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        flexShrink: 0,
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.blDark} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 12l2 2 4-4" />
                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.66 0 3.22.45 4.56 1.24" />
                        </svg>
                        <span style={{ fontSize: 13, fontWeight: 600, color: C.blDark }}>
                            {capitalizeFirstLetter(lang[languaje]['selectPermisos'] || 'Seleccionar permisos')}
                        </span>
                    </div>

                    {/* Buscador */}
                    <div style={{ position: 'relative', flex: 1, maxWidth: 360, minWidth: 200 }}>
                        <svg
                            width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke={C.txt3} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
                        >
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder={capitalizeFirstLetter(lang[languaje]['buscarModulo'] || 'Buscar módulo o submódulo...')}
                            style={{
                                width: '100%', height: 34, padding: '0 12px 0 34px',
                                border: `1px solid ${C.b1}`, borderRadius: 8,
                                fontSize: 12, color: C.txt, outline: 'none',
                                background: C.wh, boxSizing: 'border-box',
                            }}
                            onFocus={(e) => { e.target.style.borderColor = C.bl; e.target.style.boxShadow = `0 0 0 3px ${C.bl5}`; }}
                            onBlur={(e) => { e.target.style.borderColor = C.b1; e.target.style.boxShadow = 'none'; }}
                        />
                        {searchTerm && (
                            <button
                                onClick={() => setSearchTerm('')}
                                style={{
                                    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                                    width: 20, height: 20, borderRadius: 4, border: 'none',
                                    background: 'transparent', color: C.txt3, cursor: 'pointer',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}
                                title="Limpiar"
                            >
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </button>
                        )}
                    </div>

                    {/* Seleccionar todos */}
                    <label
                        style={{
                            display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
                            padding: '6px 12px', borderRadius: 8,
                            border: `1px solid ${allChecked ? C.bl : C.b1}`,
                            background: allChecked ? C.bl5 : C.wh,
                            transition: 'all 0.15s',
                            marginLeft: 'auto',
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleSelectAll}
                            style={{
                                width: 16, height: 16, cursor: 'pointer',
                                accentColor: C.bl, margin: 0,
                            }}
                        />
                        <span style={{ fontSize: 12, fontWeight: 600, color: allChecked ? C.bl : C.txt2, whiteSpace: 'nowrap' }}>
                            {totalSelected > 0
                                ? (capitalizeFirstLetter(lang[languaje]['deseleccionarTodos'] || 'Deseleccionar todos'))
                                : (capitalizeFirstLetter(lang[languaje]['seleccionarTodos'] || 'Seleccionar todos'))
                            }
                        </span>
                    </label>
                </div>

                {/* ═══════════════════════════════════════════════════════════════
            ÁRBOL DE PERMISOS
            ═══════════════════════════════════════════════════════════════ */}
                <div
                    style={{
                        flex: 1, minHeight: 0, overflow: 'auto',
                        background: C.bg, padding: '16px 20px',
                    }}
                >
                    {(dataPermisos.loading || RolData.loading) ? (
                        <div style={{ width: '100%', height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <LoadSimple />
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {filteredModules.length === 0 && (
                                <div style={{
                                    padding: 32, textAlign: 'center', color: C.txt3,
                                    background: C.wh, border: `1px dashed ${C.b1}`, borderRadius: 8,
                                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
                                }}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={C.txt4} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                    </svg>
                                    <div style={{ fontSize: 13 }}>
                                        {capitalizeFirstLetter(lang[languaje]['sinResultados'] || 'Sin resultados')}
                                        {searchTerm && (
                                            <div style={{ fontSize: 11, color: C.txt4, marginTop: 4 }}>
                                                "{searchTerm}"
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {filteredModules.map((module) => {
                                const moduleSubModules = dataPermisos.data.data.filter(el => el.Nivel === 2 && el.name === module.module_name);

                                // Auto-expandir si la búsqueda matchea un submódulo del módulo
                                const hasMatchingSubmodule = searchTerm.trim() !== '' && moduleSubModules.some(submoduleMatchesSearch);
                                const isModuleExpanded = expandedModule === module.permission_id || hasMatchingSubmodule;

                                const moduleChecked = permisos.includes(module.permission_id);
                                const subsSelectedCount = moduleSubModules.filter(s => permisos.includes(s.permission_id)).length;

                                return (
                                    <div
                                        key={module.permission_id}
                                        style={{
                                            background: C.wh,
                                            border: `1px solid ${moduleChecked ? C.bl : C.b1}`,
                                            borderRadius: 8,
                                            overflow: 'hidden',
                                            transition: 'border-color 0.15s, box-shadow 0.15s',
                                            boxShadow: moduleChecked ? `0 0 0 3px ${C.bl5}` : 'none',
                                        }}
                                    >
                                        {/* HEADER MÓDULO */}
                                        <div
                                            onClick={() => setExpandedModule(isModuleExpanded ? null : module.permission_id)}
                                            style={{
                                                display: 'flex', alignItems: 'center',
                                                padding: '12px 14px',
                                                background: isModuleExpanded ? C.bg : C.wh,
                                                cursor: 'pointer',
                                                transition: 'background 0.15s',
                                                gap: 12,
                                            }}
                                        >
                                            <svg
                                                width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                stroke={C.txt3} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                                                style={{
                                                    flexShrink: 0,
                                                    transform: isModuleExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.15s',
                                                }}
                                            >
                                                <polyline points="9 18 15 12 9 6" />
                                            </svg>

                                            <label
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flexShrink: 0 }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={moduleChecked}
                                                    onChange={() => addPermiso(module.permission_id)}
                                                    style={{
                                                        width: 16, height: 16, cursor: 'pointer',
                                                        accentColor: C.bl, margin: 0,
                                                    }}
                                                />
                                            </label>

                                            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <span style={{ fontSize: 14, fontWeight: 600, color: C.txt }}>
                                                    {capitalizeFirstLetter((lang[languaje] && lang[languaje][module.module_name]) ? lang[languaje][module.module_name] : module.module_name)}
                                                </span>

                                                {moduleSubModules.length > 0 && (
                                                    <span style={{
                                                        fontSize: 11, fontWeight: 600,
                                                        padding: '2px 8px', borderRadius: 999,
                                                        background: subsSelectedCount > 0 ? C.bl5 : C.bg2,
                                                        color: subsSelectedCount > 0 ? C.bl : C.txt3,
                                                    }}>
                                                        {subsSelectedCount}/{moduleSubModules.length}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* SUBMÓDULOS */}
                                        {isModuleExpanded && (
                                            <div style={{ background: C.bg, borderTop: `1px solid ${C.b1}` }}>
                                                {moduleSubModules.map(subm => {
                                                    // Auto-expandir submódulo si su nombre matchea la búsqueda
                                                    const subHighlighted = submoduleMatchesSearch(subm);
                                                    const isSubExpanded = expandedSubModule === subm.permission_id;

                                                    let chars = [];
                                                    if (subm.permission_id === 90) {
                                                        chars = dataSubgrups.data?.data || [];
                                                    } else {
                                                        chars = dataPermisos.data.data.filter(el => el.Nivel === 3 && el.name === module.module_name && el.description === subm.module_name);
                                                    }
                                                    const subChecked = permisos.includes(subm.permission_id);
                                                    const subDisabled = !permisos.includes(module.permission_id);

                                                    let charsSelectedCount = 0;
                                                    if (subm.permission_id === 90) {
                                                        charsSelectedCount = chars.filter(c => authGroups.includes(c.id)).length;
                                                    } else {
                                                        charsSelectedCount = chars.filter(c => permisos.includes(c.permission_id)).length;
                                                    }

                                                    return (
                                                        <div
                                                            key={subm.permission_id}
                                                            style={{
                                                                borderBottom: `1px solid ${C.b1}`,
                                                                background: subHighlighted ? C.bl5 : 'transparent',
                                                            }}
                                                        >
                                                            <div
                                                                onClick={() => chars.length > 0 && setExpandedSubModule(isSubExpanded ? null : subm.permission_id)}
                                                                style={{
                                                                    display: 'flex', alignItems: 'center',
                                                                    padding: '10px 14px 10px 42px',
                                                                    cursor: chars.length > 0 ? 'pointer' : 'default',
                                                                    gap: 12,
                                                                    transition: 'background 0.15s',
                                                                    opacity: subDisabled ? 0.5 : 1,
                                                                }}
                                                            >
                                                                {chars.length > 0 ? (
                                                                    <svg
                                                                        width="12" height="12" viewBox="0 0 24 24" fill="none"
                                                                        stroke={C.txt3} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                                                                        style={{
                                                                            flexShrink: 0,
                                                                            transform: isSubExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                                                            transition: 'transform 0.15s',
                                                                        }}
                                                                    >
                                                                        <polyline points="9 18 15 12 9 6" />
                                                                    </svg>
                                                                ) : (
                                                                    <div style={{
                                                                        width: 12, height: 12, display: 'flex',
                                                                        alignItems: 'center', justifyContent: 'center',
                                                                        flexShrink: 0,
                                                                    }}>
                                                                        <span style={{ width: 4, height: 4, borderRadius: '50%', background: C.txt4 }} />
                                                                    </div>
                                                                )}

                                                                <label
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    style={{ display: 'flex', alignItems: 'center', cursor: subDisabled ? 'not-allowed' : 'pointer', flexShrink: 0 }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={subChecked}
                                                                        onChange={() => addPermiso(subm.permission_id)}
                                                                        disabled={subDisabled}
                                                                        style={{
                                                                            width: 15, height: 15,
                                                                            cursor: subDisabled ? 'not-allowed' : 'pointer',
                                                                            accentColor: C.bl, margin: 0,
                                                                        }}
                                                                    />
                                                                </label>

                                                                <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                    <span style={{
                                                                        fontSize: 13,
                                                                        fontWeight: subHighlighted ? 600 : 500,
                                                                        color: subHighlighted ? C.bl : C.txt2,
                                                                    }}>
                                                                        {capitalizeFirstLetter((lang[languaje] && lang[languaje][subm.module_name]) ? lang[languaje][subm.module_name] : subm.module_name)}
                                                                    </span>

                                                                    {chars.length > 0 && (
                                                                        <span style={{
                                                                            fontSize: 10, fontWeight: 600,
                                                                            padding: '1px 7px', borderRadius: 999,
                                                                            background: charsSelectedCount > 0 ? C.bl5 : C.bg2,
                                                                            color: charsSelectedCount > 0 ? C.bl : C.txt3,
                                                                        }}>
                                                                            {charsSelectedCount}/{chars.length}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {isSubExpanded && chars.length > 0 && (
                                                                <div style={{
                                                                    padding: '8px 14px 14px 82px',
                                                                    display: 'flex', flexWrap: 'wrap', gap: 6,
                                                                    background: C.wh, borderTop: `1px solid ${C.b1}`,
                                                                }}>
                                                                    {chars.map(char => {
                                                                        const isGroup = subm.permission_id === 90;
                                                                        const charKey = isGroup ? char.id : char.permission_id;
                                                                        const charChecked = isGroup
                                                                            ? authGroups.includes(char.id)
                                                                            : permisos.includes(char.permission_id);
                                                                        const charLabel = isGroup ? char.name : char.module_name;
                                                                        const charDisabled = !permisos.includes(subm.permission_id);

                                                                        return (
                                                                            <label
                                                                                key={charKey}
                                                                                style={{
                                                                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                                                                    padding: '5px 10px',
                                                                                    borderRadius: 999,
                                                                                    border: `1px solid ${charChecked ? C.bl : C.b1}`,
                                                                                    background: charChecked ? C.bl5 : C.wh,
                                                                                    cursor: charDisabled ? 'not-allowed' : 'pointer',
                                                                                    opacity: charDisabled ? 0.5 : 1,
                                                                                    transition: 'all 0.12s',
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    color: charChecked ? C.bl : C.txt2,
                                                                                    whiteSpace: 'nowrap',
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={charChecked}
                                                                                    onChange={() => isGroup ? addGroups(char.id) : addPermiso(char.permission_id)}
                                                                                    disabled={charDisabled}
                                                                                    style={{
                                                                                        width: 13, height: 13,
                                                                                        cursor: charDisabled ? 'not-allowed' : 'pointer',
                                                                                        accentColor: C.bl, margin: 0,
                                                                                    }}
                                                                                />
                                                                                {capitalizeFirstLetter(charLabel)}
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                                {moduleSubModules.length === 0 && (
                                                    <div style={{
                                                        padding: '12px 14px 12px 42px',
                                                        fontSize: 12, color: C.txt3, fontStyle: 'italic',
                                                    }}>
                                                        {capitalizeFirstLetter(lang[languaje]['sinSubmodulos'] || 'Este módulo no tiene submódulos')}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* ═══════════════════════════════════════════════════════════════
            FOOTER
            ═══════════════════════════════════════════════════════════════ */}
                <div
                    style={{
                        padding: '14px 20px',
                        borderTop: `1px solid ${C.b1}`,
                        background: C.bg,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        flexShrink: 0,
                    }}
                >
                    <div style={{ flex: 1, fontSize: 12, color: C.txt3, display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {name
                                ? `${name} · ${totalSelected} ${lang[languaje]['permisosSeleccionados'] || 'permisos seleccionados'}`
                                : capitalizeFirstLetter(lang[languaje]['ingresaNombreRol'] || 'Ingresa el nombre del rol y selecciona al menos un permiso')
                            }
                        </span>
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                        {(loading) ? (
                            <LoadSimple />
                        ) : (
                            <>
                                <Action
                                    disabled={false}
                                    origen='Cancelar'
                                    titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}
                                    action={closCreateCisModal}
                                />
                                <Action
                                    disabled={disabled}
                                    origen='Azul'
                                    titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}
                                    action={Guardar}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalCreateRol;